$(function initFormSelect() {
  const formSelectElements = document.getElementsByClassName('form-select');

  // Listen for clicks outside of the Form Select, to close the list.
  document.addEventListener('click', function () {
    for (const formSelectElement of formSelectElements) {
      formSelectElement.classList.remove('active');
    }
  });

  for (const formSelectElement of formSelectElements) {
    formSelectElement.addEventListener('click', function (e) {
      this.classList.toggle('active');
      e.stopPropagation();
    });

    const input = formSelectElement.getElementsByClassName('form-select__element')[0];
    const text = formSelectElement.getElementsByClassName('form-select__text')[0];
    const options = formSelectElement.getElementsByClassName('form-select__option');
    for (const option of options) {
      option.addEventListener('click', function () {
        input.value = this.dataset.value;

        // Needed to update the custom validity of the select element.
        const event = new Event('input', {
          bubbles: true,
          cancelable: true,
        });

        input.dispatchEvent(event)
        text.innerHTML = this.innerHTML;
      });
    }

    // On reload or going back a page, the input values persist.
    // We need to set the `text.innerHTML` to reflect that too.
    if (input.value) {
      const option = [...options].find(option => option.dataset.value === input.value);
      text.innerHTML = option.innerHTML;
    }
  }
});